import { expand } from 'uri-template-lite';
import { apiClient } from '../../../../common/ApiClient';
import { createApiQueryHook } from '../../../../common/queryClient/createApiQueryHook';
import { UserDashboardSettingsDto } from '../schema/types';
import { UserDashboardSettingsUrl } from './UserDashboardSettingsUrl';

const getUserDashboardSettings = () =>
  apiClient
    .get<UserDashboardSettingsDto>(expand(UserDashboardSettingsUrl.base))
    .then((response) => response.data);

export const useGetUserDashboardSettingsQuery = createApiQueryHook(
  ['user-dashboard-settings'],
  getUserDashboardSettings
);
